import { COUNTRIES_API, INDUSTRIES_API } from "_constants";
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";

const accessTokenID = "accessToken";
const refreshTokenID = "refreshToken";


const cookieOptions = {
    path: "/",
    domain: ".empirefx.com",
    sameSite: true
}

export const getAccessToken = () => {
    return localStorage.getItem(accessTokenID) || Cookies.get(accessTokenID);
};

export const setAccessToken = (value) => {
  if (value) {
    localStorage.setItem(accessTokenID, value);
    Cookies.set(accessTokenID, 'hello world', {...cookieOptions, expires:12});
  } else {
    localStorage.removeItem(accessTokenID);
    Cookies.remove(accessTokenID, cookieOptions);
  }
};

export const getRefreshToken = () => {
  return localStorage.getItem("refreshToken") || Cookies.get(refreshTokenID);
};

export const setRefreshToken = (value = null) => {
  if (value) {
    localStorage.setItem(refreshTokenID, value);
    Cookies.set(refreshTokenID, "helloWorldRefresh", {...cookieOptions, expires:15})
  } else {
    localStorage.removeItem(refreshTokenID);
    Cookies.remove(refreshTokenID, cookieOptions);
  }
};

export const getUpdatedUser = (user, appendValue) => {
  let currentUser = { ...user } || null;

  if (typeof currentUser === "object" && typeof appendValue === "object") {
    delete appendValue.firstName;
    delete appendValue.lastName;
    delete appendValue.email;
    currentUser = { ...currentUser, ...appendValue };
  }
  return currentUser || appendValue || null;
};

export const isAuthorizationHeaderAllowed = (url) => {
  return ![INDUSTRIES_API, COUNTRIES_API].find((value) => value === url);
};

export const getSocialSignInURL = () => {
  let socialSignInUrl = new URL(process.env.REACT_APP_SOCIAL_SIGN_IN_BASE_URL);
  socialSignInUrl.searchParams.append(
    "redirect_uri",
    `${window.location.origin}${window.location.pathname}`
  );
  socialSignInUrl.searchParams.append("client_id", "efx-mw-svc");
  socialSignInUrl.searchParams.append("response_type", "code");
  socialSignInUrl.searchParams.append("kc_idp_hint", "google");

  return socialSignInUrl;
};

export const onClickSignUpOrSignInWithGoogle = () => {
  window.open(getSocialSignInURL(), "_self");
};

export const getUserFromAccessToken = (accessToken) => {
  if (!accessToken) return null;
  try {
    const user = jwtDecode(accessToken);
    if (!user) return null;
    return {
      email: user?.email,
      firstName: user?.given_name,
      lastName: user?.family_name,
    };
  } catch (error) {
    return null;
  }
};
